import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { tns } from './../../../node_modules/tiny-slider/src/tiny-slider';

import Video from './../components/video';
import ShowLines from './../components/ShowLines';
import ShowContent from './../components/ShowContent';
import Loader from './../components/loader';

export default class Home {
    constructor() {
        // Home
        gsap.registerPlugin(ScrollTrigger);

        new Loader();

        new Video();
        new ShowContent();

        let line = new ShowLines();
        line.show('text-image');
        line.show('push');

        this.showCoachs();
        this.showPartners();
        this.showTarifs();
        this.showImage();
        this.showImagePush();
        this.showTable();
        this.readMore();

        this.textImageSlider();
    }

    showCoachs() {
        const coachs = document.querySelectorAll('#coachs .coach');
        Array.from(coachs).forEach( (coach, idx) => {

            let d = 0;
            if (idx % 2 != 0) { d = .2 }

            gsap.to(
                coach.querySelector('figure .background'),
                {
                    scrollTrigger: {
                        trigger: coach,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    scaleY: 0,
                    delay: d
                }
            );

            gsap.to(
                coach.querySelector('figure img'),
                {
                    scrollTrigger: {
                        trigger: coach,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    scale: 1,
                    delay: d
                }
            );
        });
    }

    readMore() {
        const ctas = document.querySelectorAll('.read-more');
        Array.from(ctas).forEach( cta => {
            let wrapperHeight = cta.parentElement.offsetHeight;
            cta.addEventListener('click', function(){
                this.classList.toggle('open');
                this.parentElement.classList.toggle('full-content');

                if (this.classList.contains('open')) {
                    this.innerText = 'masquer';
                    gsap.from(
                        this.parentElement,
                        {
                            height: wrapperHeight,
                            ease: "power4.out",
                            duration: .85
                        }
                    );
                } else {
                    this.innerText = 'afficher la suite';
                    gsap.to(
                        this.parentElement,
                        {
                            height: wrapperHeight,
                            ease: "power4.out",
                            duration: .85,
                            onComplete: () => {
                                this.parentElement.style.height = '';
                            }
                        }
                    );
                }
            });
        } );
    }

    showPartners() {
        const partners = document.querySelector('#partenaires');

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: partners,
                start: 'top center'
            }
        });
        tl.to(
            Array.from(document.querySelectorAll('#partenaires figure .background')),
            {
                ease: "power4.out",
                duration: 1.25,
                scaleY: 0,
                stagger: .1
            }
        );

        let tln = gsap.timeline({
            scrollTrigger: {
                trigger: partners,
                start: 'top center'
            }
        });
        tln.to(
            Array.from(document.querySelectorAll('#partenaires figure img')),
            {
                ease: "power4.out",
                duration: 1.25,
                scale: 1,
                stagger: .1
            }
        );
    }

    showTarifs() {
        const tarifs = document.querySelectorAll('#tarifs .text-container');
        Array.from(tarifs).forEach( tarif => {
            gsap.to(
                tarif,
                {
                    scrollTrigger: {
                        trigger: tarif,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    opacity: 1,
                    y: 0
                }
            );

            gsap.to(
                tarif.querySelector('.dash'),
                {
                    scrollTrigger: {
                        trigger: tarif,
                        start: 'top 66%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    scale: 1
                }
            );
        } );
    }

    showImage() {
        const background = document.querySelector('#text-image figure .background');

        gsap.to(
            background,
            {
                scrollTrigger: {
                    trigger: background,
                    start: 'top 66%'
                },
                duration: 1.25,
                scaleX: 0,
                ease: "power4.out"
            }
        );
    }

    showImagePush() {
        const background = document.querySelector('#push figure .background');

        gsap.to(
            background,
            {
                scrollTrigger: {
                    trigger: background,
                    start: 'top 66%'
                },
                duration: 1.25,
                scaleY: 0,
                ease: "power4.out"
            }
        );
    }

    showTable() {
        const planningINtroductions = document.querySelectorAll('#planning .planning-content-wrapper .text-container');

        let tlIntro = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('#planning .planning-content-wrapper'),
                start: 'top 66%'
            }
        });
        tlIntro.from(
            Array.from(planningINtroductions),
            {
                ease: "power4.out",
                duration: 1.25,
                y: 40,
                opacity: 0,
                stagger: .1,
                delay: .6
            }
        );

        const tableTitles = document.querySelectorAll('#planning table.main tbody tr th span');

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: document.querySelector('#planning table.time'),
                start: 'top 66%'
            }
        });
        tl.from(
            Array.from(tableTitles),
            {
                ease: "power4.out",
                duration: 1.25,
                scaleY: 0,
                stagger: .1,
                delay: .6
            }
        );

        const tableBody = document.querySelectorAll('#planning table');
        gsap.from(
            tableBody,
            {
                scrollTrigger: {
                    trigger: document.querySelector('#planning table.time'),
                    start: 'top 66%'
                },
                ease: "power4.out",
                duration: 1.25,
                opacity: 0,
                y: -40
            }
        );
    }

    textImageSlider() {
      tns({
        container: '.images-slider',
        items: 1,
        slideBy: 'page',
        autoplay: false,
        gutter: 20,
        controlsPosition: 'bottom',
        navPosition: 'bottom',
        controlsText: ['', ''],
      });
    }
}